module.exports = __webpack_public_path__ + "static/media/allow-yes.c905de95.svg";